import { ComponentKind } from "../description";
import { SimpleComponentHandler, PropertyDescriptorWithArgumentName } from "./simple-handler";
import { SeparatorUI } from "../../components/uis";
import { PropertySection } from "./property-sections";
import { EnumPropertyHandler, SwitchPropertyHandler } from "./property-handlers";
import { SeparatorSpacing } from "./separator-spacing";

const ComponentKindSeparator: ComponentKind = "separator";

export const separatorSpacings = [
    {
        value: SeparatorSpacing.Default,
        label: "Default",
    },
    {
        value: SeparatorSpacing.Small,
        label: "Small",
    },
    {
        value: SeparatorSpacing.Medium,
        label: "Medium",
    },
    {
        value: SeparatorSpacing.Large,
        label: "Large",
    },
];

const showLinePropertyHandler = new SwitchPropertyHandler(
    { showLine: true },
    "Show line divider",
    PropertySection.Options
);

const separatorSpacingPropertyHandler = new EnumPropertyHandler(
    { size: SeparatorSpacing.Default },
    "Spacing",
    "Spacing",
    separatorSpacings,
    PropertySection.Options,
    "dropdown"
);

export class SeparatorComponentHandler extends SimpleComponentHandler {
    constructor() {
        super({
            kind: ComponentKindSeparator,
            name: "Separator",
            group: "Layout",
            description: "A horizontal line",
            img: "componentSeparator",
            uiClass: SeparatorUI,
            helpPath: "separator",
        });
    }

    protected getPropertyDescriptors(): readonly PropertyDescriptorWithArgumentName[] {
        return [
            {
                descriptor: separatorSpacingPropertyHandler,
                argumentName: "spacing",
            },
            {
                descriptor: showLinePropertyHandler,
                argumentName: "showLine",
            },
        ];
    }

    public get needsColumns(): boolean {
        return false;
    }
}
